import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=1debd756"
import script from "./CompanyCard.vue?vue&type=script&lang=js"
export * from "./CompanyCard.vue?vue&type=script&lang=js"
import style0 from "./CompanyCard.vue?vue&type=style&index=0&id=1debd756&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports